// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602041533/js/" + chunkId + "." + {"44":"186ca9ca","225":"6ac7c85d","481":"93b23a03","486":"c1a19ab2","770":"c468bfba"}[chunkId] + ".0.959525357138667.chunk.js";
};